document.addEventListener("DOMContentLoaded", init);

function renderSkeletons(count = 8) {
    const container = document.getElementById("brand-category-links");
    if (!container) return;

    container.innerHTML = "";

    for (let i = 0; i < count; i++) {
        const li = document.createElement("li");
        li.className = "brand-category-item skeleton-card";

        const imgPlaceholder = document.createElement("div");
        imgPlaceholder.className = "skeleton-image";

        const textPlaceholder = document.createElement("div");
        textPlaceholder.className = "skeleton-text";

        li.appendChild(imgPlaceholder);
        li.appendChild(textPlaceholder);
        container.appendChild(li);
    }
}

async function init() {

    const container = document.getElementById("brand-category-links");

    if (!container) return;

    renderSkeletons();

    const vendor = window.currentVendor;
    const categories = window.brandCategories;

    try {

        const results = await Promise.all(
            categories.map(category => checkCategory(category, vendor))
        );

        renderCategories(results, vendor);

    } catch (err) {

        console.error(err);
        container.innerHTML = "<li>Unable to load categories.</li>";

    }

}
function upsizeShopifyImage(url, width = 400) {
    if (!url) return url;
    try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set("width", width);
        return u.toString();
    } catch (e) {
        return url;
    }
}

async function checkCategory(category, vendor) {

    const url =
        `${window.location.origin}${category.url}?filter.p.vendor=${encodeURIComponent(vendor)}&section_id=main-collection-product-grid`;

    try {

        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(response.status);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const productGrid = doc.querySelector("#product-grid");

        if (!productGrid) {
            return { ...category, hasProducts: false };
        }

        const empty = productGrid.classList.contains("collection--empty");

        let image = null;

        if (!empty) {
            const primaryImg = productGrid.querySelector("img.product-primary-image");

            if (primaryImg) {
                const rawSrc =
                    primaryImg.getAttribute("data-srcset")?.split(",")[0]?.trim().split(" ")[0] ||
                    primaryImg.getAttribute("srcset")?.split(",")[0]?.trim().split(" ")[0] ||
                    primaryImg.getAttribute("data-src") ||
                    primaryImg.getAttribute("src");

                if (rawSrc) {
                    const fullSrc = rawSrc.startsWith("//") ? `https:${rawSrc}` : rawSrc;
                    image = upsizeShopifyImage(fullSrc, 400);
                }
            }
        }

        return {
            ...category,
            image,
            hasProducts: !empty
        };

    } catch (err) {
        console.warn(category.title, err);
        return { ...category, hasProducts: false };
    }
}

function renderCategories(results, vendor) {

    const nav = document.getElementById("brand-category-nav");
    const container = document.getElementById("brand-category-links");

    const visibleCategories = results.filter(category => category.hasProducts);

    if (visibleCategories.length === 0) {
        nav.style.display = "none";
        return;
    }

    container.innerHTML = "";

    visibleCategories.forEach(category => {

        const li = document.createElement("li");
        li.className = "brand-category-item";

        const a = document.createElement("a");
        a.className = "brand-category-link";
        a.href = `${category.url}?filter.p.vendor=${encodeURIComponent(vendor)}&sort_by=manual`;

        if (category.image) {
            const img = document.createElement("img");
            img.src = category.image;
            img.alt = category.title;
            img.loading = "lazy";
            img.className = "brand-category-image";
            a.appendChild(img);
        }

        const span = document.createElement("span");
        span.className = "brand-category-title";
        span.textContent = category.title;
        a.appendChild(span);

        li.appendChild(a);
        container.appendChild(li);
    });
}